import React from 'react';
import ReactDOM from 'react-dom';
import {Container, Row, Col} from 'react-grid-system';
import {Drawable} from "../../../../../res/images/Drawable";
import {getMobileOperatingSystem, OS} from "../../../../../utils/CheckPlatform";

interface States {
}

interface Props {
    text: String
}

class QRCode extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <Col
                className="imageContainer"
                lg={6}>
                <img
                    className="qrcode"
                    src={"https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=" + encodeURIComponent(this.props.text.toString())}
                    hidden={getMobileOperatingSystem() !== OS.unknow}
                />
            </Col>
        )
    }
}

export default QRCode;
